/*@flow*/
import type { Node } from 'react';
import React, { useState, useContext, Fragment } from 'react';
import commands from './commands';
import context from './context';
import Present from 'lib/Present';
import geocode from 'lib/geocode';
import * as I from 'immutable';

export default function RevGeocodeButton(props: {
  isWorking?: boolean,
  errors?: string[],
  className?: string,
}): Node {
  const [geocoded, setGeocoded] = useState(I.Map());
  const [isWorking, setWorking] = useState(Boolean(props.isWorking));
  const [errors, setErrors] = useState(props.errors || []);
  const ctx = useContext(context);
  const { center } = ctx.state;
  const latlon = center && Present.is(center) ? [center.lat, center.lon] : null;
  const isDisabled = isWorking || !latlon;

  const onClick = () => {
    if (!latlon) return;
    if (isWorking) return;

    if (geocoded.has(I.List(latlon))) {
      const address = geocoded.get(I.List(latlon));
      address && commands(ctx).setFullAddress(address);
      return;
    }

    setWorking(true);
    setErrors([]);
    geocode(latlon)
      .then((address) => {
        setTimeout(() => setWorking(false), 400);
        if (!address) return;
        setGeocoded((v) => v.set(I.List(latlon), address));
        address && commands(ctx).setFullAddress(address);
      })
      .catch((err) => {
        setWorking(false);
        setErrors(Array.isArray(err) ? err : [err]);
      });
  };

  const txt = isWorking ? 'Searching address...' : 'Find address';
  let style: {
    color?: string,
    cursor: string,
    textDecoration?: string,
  } = isWorking
    ? { cursor: 'default', textDecoration: 'none', color: '#ccc' }
    : { cursor: 'pointer' };

  if (Present.is(errors)) {
    style.color = 'red';
  }

  if (isDisabled) {
    style.cursor = 'no-drop';
  }

  return (
    <Fragment>
      <a
        style={{ color: '#999', ...style }}
        disabled={isDisabled}
        onClick={onClick}
        data-testid="RevGeocodeButton"
        className={props.className || ''}
      >
        <i className="far fa-address-card" /> {txt}
      </a>
      {Present.is(errors) && (
        <a
          onClick={() => setErrors([])}
          className="text-danger ml-3 d-inline-block"
        >
          {errors[0]}
        </a>
      )}
    </Fragment>
  );
}
